import { BRAND } from "constants/brand";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import useOptions from "hooks/useOptions";
import OptionGroup from "./OptionGroup/OptionGroup";
import useGroups from "hooks/useGroups";
import { readApiError } from "utils/apiError";

const EditOptions = (props) => {
    const form = useRef();
    const nodeRef = useRef();
    const { loading, editGroupOptions } = useGroups();
    const [productOptions, setProductOptions] = useState([]);
    const { options, fetchOptions } = useOptions();

    useEffect(() => {
        fetchOptions({});
    }, []);

    const getOptionData = (data) => {
        const options = productOptions.filter((option) => +option.id !== +data.id);
        options.push(data);
        setProductOptions(options);
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        try {
            const groupFormData = new FormData();
            groupFormData.append("groupsData", JSON.stringify(productOptions));

            productOptions.forEach((group, groupIndex) => {
                group.options.forEach((option, optionIndex) => {
                    // Example: if you have a File object for this option
                    const file = option.image; // 👈 must come from <input type="file" /> or similar

                    if (file) {
                        // The key includes indexes so the backend knows which option this image belongs to
                        groupFormData.append(
                            `groups[${groupIndex}][options][${optionIndex}][image]`,
                            file,
                        );
                    }
                });
            });
            const response = await editGroupOptions(props.group.id, groupFormData);
            // The hook RETURNS a failed call: show the sentence of the server,
            // and keep the form open.
            const failure = readApiError(response, "تعذر حفظ الخيار");
            if (failure) {
                props.showMessage("error", "هناك خطأ", failure);
                return;
            }

            props.showMessage("success", "تمت الاضافه", "تمت إضافه القسم بنجاح");
            props.close(); // Uncomment if you need to close a modal or similar
        } catch (err) {
            console.error("Error adding vendor:", err);
            props.showMessage("error", "هناك خطأ", readApiError(err, "حدث خطأ غير متوقع"));
        }
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div className="addItem" ref={nodeRef} onClick={(e) => e.stopPropagation()}>
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div className="head center">
                            <h5>تعديل إضافه</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <OptionGroup
                                index={1}
                                getOptionData={getOptionData}
                                options={options}
                                group={props.group}
                            />
                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    إضافه
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default EditOptions;
